import dayjs from 'dayjs';

// 開始時刻をUnixtimeに変換
const toUnixtimeForBgn = (time) => {
  let ret = 0;
  if (time) ret = dayjs(time).unix();

  return ret;
};

// 終了時刻をUnixtimeに変換
const toUnixtimeForEnd = (time) => {
  let ret = dayjs().unix();
  if (time) ret = dayjs(time).unix();

  return ret;
};

// 受講履歴のCSVエクスポートボタン
export default () => {
  const button = document.getElementById('attendance_export_button');
  if (!button) return;

  button.addEventListener('click', (e) => {
    const createdAtBgn = toUnixtimeForBgn(document.getElementById('q_created_at_gteq').value);
    const createdAtEnd = toUnixtimeForEnd(document.getElementById('q_created_at_lt').value);
    const startedAtBgn = toUnixtimeForBgn(document.getElementById('q_started_at_gteq').value);
    const startedAtEnd = toUnixtimeForEnd(document.getElementById('q_started_at_lt').value);
    const endedAtBgn = toUnixtimeForBgn(document.getElementById('q_ended_at_gteq').value);
    const endedAtEnd = toUnixtimeForEnd(document.getElementById('q_ended_at_lt').value);

    const latestBgn = Math.max(createdAtBgn, startedAtBgn, endedAtBgn);
    const oldestEnd = Math.min(createdAtEnd, startedAtEnd, endedAtEnd);

    if (oldestEnd - latestBgn > 60 * 60 * 24 * 31) {
      // 1ヶ月以上の期間を指定しているとき
      if (
        !window.confirm(
          '長期間の受講履歴をダウンロードしようとしています。\nこの操作には時間がかかる場合があります。\n実行してよろしいですか？',
        )
      ) {
        e.preventDefault();

        return;
      }
    }

    button.classList.add('disabled');
    setTimeout(() => {
      button.classList.remove('disabled');
    }, 3000);
  });
};
